import { useState } from 'react';

const CONTACT_FORM_URL = 'https://readdy.ai/api/form/d9liffe8mbnljin59dtg';

export default function SectionContact() {
  const [formState, setFormState] = useState<'idle' | 'submitting' | 'success' | 'error'>('idle');
  const [formError, setFormError] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const honeypot = (form.querySelector('[name="phone_alt"]') as HTMLInputElement)?.value?.trim();
    if (honeypot) {
      setFormState('success');
      return;
    }

    setFormState('submitting');
    setFormError('');

    try {
      const formData = new FormData(form);
      const response = await fetch(CONTACT_FORM_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const responseText = await response.text();
      let parsed;
      try { parsed = JSON.parse(responseText); } catch { parsed = null; }

      if (response.ok && parsed?.code === 'OK') {
        setFormState('success');
        form.reset();
      } else {
        setFormState('error');
        setFormError(parsed?.meta?.message || parsed?.message || '提交失败，请稍后重试');
      }
    } catch {
      setFormState('error');
      setFormError('网络错误，请检查连接后重试');
    }
  };

  return (
    <section id="contact" className="w-full py-16 md:py-20 bg-background-50">
      <div className="w-full px-6 md:px-10">
        <div className="max-w-[1200px] mx-auto">
          <div className="text-center mb-10">
            <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full text-xs font-medium bg-primary-100 text-primary-700 mb-4 whitespace-nowrap">
              <i className="ri-send-plane-line"></i> 我有猛料
            </span>
            <h2 className="font-heading text-3xl md:text-4xl text-foreground-950 mb-3">
              投稿爆料
            </h2>
            <p className="text-sm md:text-base text-foreground-600 max-w-[560px] mx-auto leading-relaxed">
              你手上有独家黑料？欢迎匿名投稿，审核通过后将纳入黑料热度排行榜展示。
            </p>
          </div>

          <div className="max-w-[640px] mx-auto bg-background-100 rounded-2xl p-8 md:p-10">
            {formState === 'success' ? (
              <div className="text-center py-8">
                <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center bg-primary-100 rounded-full">
                  <i className="ri-check-line text-3xl text-primary-500"></i>
                </div>
                <h3 className="font-heading text-xl text-foreground-950 mb-2">投稿已收到！</h3>
                <p className="text-sm text-foreground-600">我们的审核团队将在24小时内处理您的爆料。</p>
                <button
                  onClick={() => setFormState('idle')}
                  className="whitespace-nowrap mt-6 px-6 py-2.5 bg-primary-500 hover:bg-primary-600 text-background-50 rounded-full text-sm font-medium transition-colors cursor-pointer"
                >
                  继续投稿
                </button>
              </div>
            ) : (
              <form onSubmit={handleSubmit} data-readdy-form="">
                {/* Honeypot */}
                <input
                  type="text"
                  name="phone_alt"
                  tabIndex={-1}
                  autoComplete="off"
                  aria-hidden="true"
                  readOnly
                  className="honeypot-field"
                />

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 mb-5">
                  <div>
                    <label className="block text-sm font-medium text-foreground-700 mb-2">
                      你的昵称 <span className="text-primary-500">*</span>
                    </label>
                    <input
                      type="text"
                      name="nickname"
                      required
                      placeholder="匿名吃瓜群众"
                      className="w-full px-4 py-3 bg-background-50 border border-background-300 rounded-lg text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition-all"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-foreground-700 mb-2">
                      爆料类型 <span className="text-primary-500">*</span>
                    </label>
                    <select
                      name="type"
                      required
                      className="w-full px-4 py-3 bg-background-50 border border-background-300 rounded-lg text-sm text-foreground-900 focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition-all appearance-none cursor-pointer"
                    >
                      <option value="">请选择类型</option>
                      <option value="celebrity">明星八卦</option>
                      <option value="influencer">网红翻车</option>
                      <option value="brand">品牌塌房</option>
                      <option value="variety">综艺争议</option>
                      <option value="other">其他爆料</option>
                    </select>
                  </div>
                </div>

                <div className="mb-5">
                  <label className="block text-sm font-medium text-foreground-700 mb-2">
                    爆料标题 <span className="text-primary-500">*</span>
                  </label>
                  <input
                    type="text"
                    name="title"
                    required
                    placeholder="一句话概括你的爆料内容"
                    maxLength={100}
                    className="w-full px-4 py-3 bg-background-50 border border-background-300 rounded-lg text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition-all"
                  />
                </div>

                <div className="mb-6">
                  <label className="block text-sm font-medium text-foreground-700 mb-2">
                    详细内容 <span className="text-primary-500">*</span>
                  </label>
                  <textarea
                    name="content"
                    required
                    rows={5}
                    maxLength={500}
                    placeholder="请详细描述爆料内容（不超过500字）..."
                    className="w-full px-4 py-3 bg-background-50 border border-background-300 rounded-lg text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition-all resize-none"
                  ></textarea>
                  <p className="text-xs text-foreground-500 mt-1.5">最多500字</p>
                </div>

                {formState === 'error' && (
                  <div className="mb-5 p-4 bg-primary-50 border border-primary-200 rounded-lg">
                    <p className="text-sm text-primary-700 flex items-center gap-2">
                      <i className="ri-error-warning-line"></i>
                      {formError || '提交失败，请稍后重试'}
                    </p>
                  </div>
                )}

                <button
                  type="submit"
                  disabled={formState === 'submitting'}
                  className="whitespace-nowrap w-full py-3.5 bg-primary-500 hover:bg-primary-600 disabled:bg-primary-400 text-background-50 font-semibold rounded-full text-sm transition-all duration-200 cursor-pointer flex items-center justify-center gap-2"
                >
                  {formState === 'submitting' ? (
                    <>
                      <i className="ri-loader-4-line animate-spin"></i>
                      提交中...
                    </>
                  ) : (
                    <>
                      <i className="ri-send-plane-fill"></i>
                      匿名提交爆料
                    </>
                  )}
                </button>
              </form>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}